import { motion } from 'framer-motion';
import React from 'react';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { FocusedAsset } from '../use-focused-asset';
import css from './details-dynamic-button-row.module.scss';
import { ProgramSecondaryButtonsRow } from './program-secondary-buttons-row';
import { listProps } from './secondary-buttons-variants';
import { SvodSecondaryButtonsRow } from './svod-secondary-buttons-row';
import { ThirdPartySecondaryButtonsRow } from './third-party-secondary-buttons-row';
import VodSecondaryButtonsRow from './vod-secondary-buttons-row';

export interface DetailsDynamicButtonRowProps {
  asset: Asset;
  focusedAsset: FocusedAsset;
  source: Source;
}

export function DetailsDynamicButtonRow({ asset, focusedAsset, source }: DetailsDynamicButtonRowProps) {
  return (
    <motion.div className={css.container} {...listProps(source.id)}>
      <SecondaryActionButtons asset={asset} focusedAsset={focusedAsset} source={source} />
    </motion.div>
  );
}

function SecondaryActionButtons({ asset, focusedAsset, source }: DetailsDynamicButtonRowProps) {
  switch (source.type) {
    case 'program':
      return <ProgramSecondaryButtonsRow asset={asset} focusedAssed={focusedAsset} source={source} />;
    case 'thirdparty':
      return <ThirdPartySecondaryButtonsRow asset={asset} source={source} />;
    case 'svod':
      return <SvodSecondaryButtonsRow asset={asset} focusedAssed={focusedAsset} source={source} />;
    case 'vod':
      return <VodSecondaryButtonsRow asset={asset} focusedAssed={focusedAsset} source={source} />;
    default:
      // @ts-expect-error
      throw new Error(`Source type of ${source.type} not supported.`);
  }
}
